/**
 * Filter asynchronous routing tables by recursion
 * @description filter router by callbackFn
 * @param {import('vue-router').RouteConfig[]} routerList router config List
 * @param {() => boolean} callbackFn Determine when to add current route to the list
 */
export function genFrontendRouters(routerList, callbackFn) {
  const routers = []
  routerList.forEach(route => {
    const tmp = { ...route }
    if (tmp.children) {
      tmp.children.forEach(item => {
        // if child have no permission, then it will inherit from parent route
        if (!item.meta.permission && tmp.meta.permission) {
          item.meta.permission = tmp.meta.permission
        }
      })
      const children = genFrontendRouters(tmp.children, callbackFn)
      if (children.length) {
        tmp.children = children
        routers.push(tmp)
      }
    } else if (!callbackFn || callbackFn(tmp)) {
      routers.push(tmp)
    }
  })
  return routers
}
